import Box from 'components/shared/Box'
import Loader from 'components/shared/Loader'
import styled from 'styled-components/macro'

const LoaderWrapper = styled(Box)`
    height: 100%;
`

const FullPageLoader = () => (
    <LoaderWrapper align="center" justify="center">
        <Loader />
    </LoaderWrapper>
)

export default FullPageLoader
